<template>
  <div class="w-full sm:w-4/5">
    <div class="input-group sm:mr-8">
      <input
        v-model="queryString.query"
        type="text"
        placeholder="Search Access Requests"
      >
      <button
        class="btn btn-sm"
        type="submit"
        v-text="'Search'"
      />
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'AccessRequestsFilter',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({
        query: '',
      }),
    },
  },
  computed: {
    queryString: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit(value)
      },
    },
  },
}
</script>
